import { Reducer } from 'redux'
import type {
  OnboardingVerificationState,
  VerifiableModule,
  AuditEntry,
  ModuleStatus,
  ModuleVerification,
} from './types'

export enum VerificationActions {
  HYDRATE_PARTNER = 'onboardingVerification/HYDRATE_PARTNER',
  SET_MODULE_STATUS = 'onboardingVerification/SET_MODULE_STATUS',
}

type Action =
  | {
      type: VerificationActions.HYDRATE_PARTNER
      payload: {
        partnerId: string
        modules: Partial<Record<VerifiableModule, ModuleVerification>>
        auditLog: AuditEntry[]
      }
    }
  | {
      type: VerificationActions.SET_MODULE_STATUS
      payload: {
        partnerId: string
        module: VerifiableModule
        status: ModuleStatus
      }
    }

const initialState: OnboardingVerificationState = { byPartner: {} }

export const onboardingVerificationReducer: Reducer<
  OnboardingVerificationState,
  Action
> = (state = initialState, action) => {
  switch (action.type) {
    case VerificationActions.HYDRATE_PARTNER: {
      const { partnerId, modules, auditLog } = action.payload
      return {
        ...state,
        byPartner: {
          ...state.byPartner,
          [partnerId]: { modules, auditLog },
        },
      }
    }
    case VerificationActions.SET_MODULE_STATUS: {
      const { partnerId, module, status } = action.payload
      const partner = state.byPartner[partnerId] ?? {
        modules: {},
        auditLog: [],
      }
      const existing = partner.modules[module]

      return {
        ...state,
        byPartner: {
          ...state.byPartner,
          [partnerId]: {
            ...partner,
            modules: {
              ...partner.modules,
              [module]: {
                module,
                status,
                checkResults: existing?.checkResults ?? {},
                confirmedBy: existing?.confirmedBy ?? '',
                confirmedAt: existing?.confirmedAt ?? '',
              },
            },
          },
        },
      }
    }
    default:
      return state
  }
}
